import { useBunja } from 'bunja/react';
import { useAtomValue } from 'jotai';
import { useEffect, useRef } from 'react';

import { TextButton } from '@flipster/react/design-system/text-button';
import { Explain } from '@flipster/react/design-utils/explain';
import segment from '@flipster/utils/segment';
import { TradeEvent } from '@flipster/utils/segment/events/trade';

import { adjustLeverageModalBunja } from '../state';

interface LeverageErrorProps {
  message: string;
  action?: {
    label: string;
    onClick: () => void;
  };
}

export const LeverageError = ({ message, action }: LeverageErrorProps) => {
  const { currentPositionAtom, leverageAtom } = useBunja(adjustLeverageModalBunja);
  const prevMessageRef = useRef<string>(undefined);
  const leverage = useAtomValue(leverageAtom);
  const currentPosition = useAtomValue(currentPositionAtom);

  useEffect(() => {
    if (!currentPosition?.symbol || message === prevMessageRef.current) return;
    prevMessageRef.current = message;
    segment.track(TradeEvent.OrderFormErrorMsgView, {
      error_message: message,
      error_case: 'adjust_leverage',
      is_recommendation_chip_visible: false,
      symbol: currentPosition.symbol,
      leverage,
      order_by_token: null,
    });
  }, [message, currentPosition?.symbol, leverage]);

  return (
    <Explain.Error hideIcon css={{ textStyle: 'Text/M/Regular', display: 'inline' }}>
      {message}{' '}
      {action && (
        <TextButton
          color='sell'
          onClick={() => {
            segment.track(TradeEvent.OrderFormErrorMsgClick, {
              error_message: message,
              error_case: 'adjust_leverage',
              symbol: currentPosition?.symbol ?? '',
              leverage,
              order_by_token: null,
            });
            action.onClick();
          }}
          label={action.label}
          size='medium'
        />
      )}
    </Explain.Error>
  );
};
